<template>
  <layout-main-inner>
    <template slot="action">
      <el-button
        slot="action"
        type="primary"
        size="small"
        @click="create">新增人员</el-button>
    </template>
    <layout-card-wrap hasHeaderSlot>
      <div slot="form">
        <el-input
          v-model="config.title"
          clearable
          placeholder="请输入内容标题"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </div>
      <el-table
        border
        :data="list">
        <el-table-column
          label="人员姓名"
          prop="name"
          min-width="100"></el-table-column>
        <el-table-column
          label="职业"
          min-width="100"
          prop="work"></el-table-column>
        <el-table-column
          min-width="120"
          label="联系电话"
          prop="phone"></el-table-column>
        <el-table-column
          min-width="280"
          label="人员简介"
          prop="briefIntroduction"></el-table-column>
        <el-table-column
          label="排序值"
          width="80"
          prop="sortNumber"></el-table-column>
        <el-table-column
          label="状态"
          width="80"
          prop="status"
          :formatter="row => row.status === 1 ? '已上架' : '已下架'"></el-table-column>
        <el-table-column
          label="操作"
          width="110">
          <template slot-scope="{row}">
            <el-button
              type="text"
              @click="update(row)">编辑</el-button>
            <el-dropdown>
              <el-button
                type="text"
                style="margin-left: 10px;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :disabled="row.status === 1"
                  @click.native="onsale(row, 1)">上架人员</el-dropdown-item>
                <el-dropdown-item
                  :disabled="row.status === 0"
                  @click.native="onsale(row, 0)">下架人员</el-dropdown-item>
                <el-dropdown-item @click.native="showDetail(row)">查看人员详情</el-dropdown-item>
                <el-dropdown-item @click.native="deleteRow(row)">删除人员</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </layout-card-wrap>
    <edit-expert-modal
      ref="edit"
      @fetch="fetchList" />

    <expert-detail-drawer ref="detail" />
  </layout-main-inner>
</template>
<script>
import Expert from '@/service/expert'
import EditExpertModal from './busi/edit-expert-modal.vue'
import ExpertDetailDrawer from './busi/expert-detail-drawer.vue'
export default {
  name: 'ExpertList',
  components: { EditExpertModal, ExpertDetailDrawer },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, title: '' }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    showDetail(row) {
      this.$refs.detail.fetch({ id: row.id })
    },
    update(row) {
      const { id, briefIntroduction, detailedImages, headPicture, name, phone, sortNumber, status, work } = row
      this.$refs.edit.init({ id, briefIntroduction, detailedImages, headPicture, name, phone, sortNumber, status, work })
    },
    create() {
      this.$refs.edit.init({ })
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Expert.getexperts({ ...this.config })
        .then(res => {
          const { result, message, records, total } = res.data
          this.loading = false
          if ([0, 13].includes(result)) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    onsale(row, status) {
      const title = status === 1 ? '上架' : '下架'
      this.$confirm(`您确定${title}该人员?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Expert.updateexpert({ id: row.id, status })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.$message.success(title + '成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    deleteRow(row) {
      this.$confirm('您确定删除该条人员?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Expert.deleteexpert({ id: row.id })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    }
  }
}
</script>
